import React, { useState } from 'react';
import CreatePassword from './NewPassword';
import ConfirmPassword from './ConfirmPassword';
import PasswordResponse, { MessageType } from '../../components/PasswordResponse';
import { VoeBizApi } from '../../services/services';

interface ChangePasswordProps {
  smilesToken: string;
}
const ChangePassword: React.FC<ChangePasswordProps> = ({ smilesToken }) => {
  const api = VoeBizApi();
  const [isCreatingPassword, setIsCreatingPassword] = useState<boolean>(true);
  const [isConfirmingPassword, setIsConfirmingPassword] = useState<boolean>(false);
  const [responseType, setResponseType] = useState<MessageType | undefined>(undefined);
  const [finish, setFinish] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [password, setPassword] = useState<string>('');
  const handleOnCreated = (passwordCreated: string) => {
    setPassword(passwordCreated);
    setIsCreatingPassword(false);
    setIsConfirmingPassword(true);
  };
  const handleOnRepeated = async (newPassword: string) => {
    setIsLoading(true);
    const { success, response } = await api.changePasswordNotLogged(smilesToken, newPassword);
    setIsLoading(false);
    setIsCreatingPassword(false);
    let message = MessageType.SuccessPassword;
    if (!success) {
      if (response.smilesInvalidPassword) {
        message = MessageType.FailurePasswordSecurity;
      } else if (response.statusCode === 500) {
        message = MessageType.FailureGeneric;
      } else {
        message = MessageType.FailurePassword;
      }
    }
    setResponseType(message);
    setIsConfirmingPassword(false);
    setFinish(true);
  };
  const handleGoBack = () => {
    setIsConfirmingPassword(false);
    setIsCreatingPassword(true);
  };

  return (
    <>
      {isCreatingPassword && <CreatePassword onFinish={handleOnCreated} />}
      {isConfirmingPassword && (
        <ConfirmPassword
          password={password}
          onFinish={handleOnRepeated}
          onGoBack={handleGoBack}
          isLoading={isLoading}
        />
      )}
      {finish && <PasswordResponse message={responseType} />}
    </>
  );
};

export default ChangePassword;
